import dynamic from 'next/dynamic'
import { useTranslation } from '@mc/i18n'
import Nav from '@mc/navigation'
import { paths } from '@mc/paths'
import { MenuLinkGiftingOnMobileNavExp } from '@mc/promos'
import { NavigationEvents } from '@mc/track-event'
import { businessPath } from 'libs/paths'
import { trackNavClick, trackPlansClick, trackGiftCTAClick } from '../../events'
import { Callout } from './Callout'

const Search = dynamic(
  () => import(/* webpackChunkName: 'mobile-nav-search' */ './Search'),
  { ssr: false },
)

const Menu = () => {
  const { t } = useTranslation('@mc/next')

  const handleAtWorkClick = () => {
    trackNavClick('At Work', NavigationEvents.LEVELS.SECONDARY)()
  }

  return (
    <>
      <Search />

      <Nav.MenuLink
        href={paths.checkout}
        onClick={trackPlansClick(NavigationEvents.LEVELS.SECONDARY)}
      >
        <MenuLinkGiftingOnMobileNavExp Control={t('nav.cta.plans')} />
      </Nav.MenuLink>

      <Nav.MenuLink
        href={businessPath()}
        target='_blank'
        rel='noopener noreferrer'
        onClick={handleAtWorkClick}
      >
        {t('nav.cta.work')}
      </Nav.MenuLink>

      <Nav.MenuLink
        href={paths.gift}
        onClick={() =>
          trackGiftCTAClick({ level: NavigationEvents.LEVELS.SECONDARY })
        }
      >
        {t('nav.cta.gift')}
      </Nav.MenuLink>

      <Nav.MenuLink
        href={paths.helpCenter}
        onClick={trackNavClick('Support', NavigationEvents.LEVELS.SECONDARY)}
      >
        {t('nav.cta.support')}
      </Nav.MenuLink>

      <Nav.MenuLink
        href={paths.logIn()}
        onClick={trackNavClick('Log In', NavigationEvents.LEVELS.SECONDARY)}
      >
        {t('nav.cta.login')}
      </Nav.MenuLink>
      <Callout />
    </>
  )
}

export default Menu
